import DOMPurify from 'dompurify'

// Centralized HTML sanitizer for any user/document/email/R2-derived HTML that
// gets injected via dangerouslySetInnerHTML (ENT-002). Uses DOMPurify's default
// rich-text profile: strips <script>/<iframe>/<object>/<embed>, inline event
// handlers (on*), javascript: URLs, and other XSS vectors while keeping the
// formatting tags that document/email/playbook previews rely on.
//
// Use this for Mammoth (DOC/DOCX -> HTML) previews, playbook/knowledge-base
// content, and any other untrusted rich HTML BEFORE injection. Trivially-static
// or already-DOMPurify-sanitized sites do NOT need to route through this.
export function safeHtml(html: string | null | undefined): string {
  if (!html) return ''
  return DOMPurify.sanitize(html)
}
